/* Kit Builder — whole-bundle removal in cart surfaces.
   One click zeroes every line sharing the bundle's _kit_id via a single
   /cart/update.js call (keys carried on data-kit-keys, per Shane's MBS pattern).
   Loaded globally from theme.liquid; delegated + idempotent. */
(function () {
  'use strict';
  if (document.documentElement.dataset.kitCartBound) return;
  document.documentElement.dataset.kitCartBound = 'true';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kit-remove]');
    if (!btn || btn.dataset.kitBusy) return;
    e.preventDefault();
    e.stopPropagation();
    btn.dataset.kitBusy = 'true';

    var updates = {};
    (btn.getAttribute('data-kit-keys') || '').split(',').forEach(function (pair) {
      var key = pair.split('|')[0];
      if (key) updates[key] = 0;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: ['mini-cart', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(async function (json) {
        if (btn.dataset.kitSource === 'yusk-core-routine') {
          var events = window.FGSECOMAPP && window.FGSECOMAPP.CUSTOM_EVENTS;
          if (events && events.BOGOS_FG_INIT && events.BOGOS_FG_END) {
            // BOGOS also serves other offers. Let it decide which gifts remain
            // before redrawing, rather than deleting a shared gift ourselves.
            await new Promise(function (resolve) {
              var timer;
              function done() {
                clearTimeout(timer);
                document.removeEventListener(events.BOGOS_FG_END, done);
                resolve();
              }
              document.addEventListener(events.BOGOS_FG_END, done);
              timer = setTimeout(done, 6000);
              document.dispatchEvent(new CustomEvent(events.BOGOS_FG_INIT));
            });
            // Sections returned by the initial update predate gift cleanup.
            window.location.reload();
            return;
          }
        }
        if (window.location.pathname.indexOf('/cart') === 0) {
          window.location.reload();
          return;
        }
        var mc = document.querySelector('mini-cart');
        if (mc && typeof mc.renderContents === 'function' && json.sections) {
          mc.renderContents(json);
        } else {
          window.location.reload();
        }
      })
      .catch(function () { window.location.reload(); })
      .finally(function () { delete btn.dataset.kitBusy; });
  });
})();
